/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `CHEMICALS` - Chemicals * `FABRIC` - Fabric
 */

export const CategoryEnum = {
  Chemicals: "CHEMICALS",
  Fabric: "FABRIC",
} as const;

export type CategoryEnum = (typeof CategoryEnum)[keyof typeof CategoryEnum];
